import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 3.76c-3.129 0-5.665 2.598-5.665 5.803 0 2.374 3.107 7.597 4.719 10.147a1.11 1.11 0 001.892 0c1.612-2.55 4.719-7.774 4.719-10.147 0-3.205-2.536-5.803-5.665-5.803zM12 12a2.575 2.575 0 110-5.15A2.575 2.575 0 0112 12z"
}), 'MapPinFilled');